module.exports = __webpack_public_path__ + "assets/media/shorts-about.400078f8.svg";